import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-error-bis-modal',
    templateUrl: './error-modal.component.html',
})
export class ErrorBisModalComponent {
    @Input() public error: string;
}
